import React, { useEffect } from 'react';
import { useNewAptitudeTestScoreQuery } from '../NewAptitudeQuizSlice';
import Loading from 'components/global/layout/Loading';
import { useGetSummaryQuery } from 'components/dashboard/panel/panelSlice';
import NewShowFinalScore from './NewShowFinalScore';

const NewAptitudeScoreCard = () => {
  // changed this: useNewAptitudeTestScoreQuery , according to new aptitude slice
  const { isLoading, isSuccess, data } = useNewAptitudeTestScoreQuery();
  const { refetch } = useGetSummaryQuery({});
  const condition = Boolean(data);
  //Fetch summary so that user sees updated score after navigating to the home screen
  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      {isLoading && <Loading />}
      {isSuccess && !condition && <div>No Score Found</div>}
      {isSuccess && condition && <NewShowFinalScore data={data} />}
    </>
  );
};

export default NewAptitudeScoreCard;
